import { Link, useNavigate } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth";
import { ContactForm } from "./ContactForm";

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <>
      <nav className="nav">
        <div className="container nav-inner">
          <Link to="/" className="brand" data-testid="brand">
            <span className="dot" aria-hidden />
            The Game <span className="b">Dude</span>
          </Link>
          <div className="nav-links">
            {user ? (
              // Internal/product nav — only shown to authenticated team members.
              <>
                <Link to="/dashboard" data-testid="nav-dashboard">Dashboard</Link>
                {user.role === "admin" && <Link to="/admin">Admin</Link>}
                <button
                  className="btn btn-ghost btn-sm"
                  data-testid="logout"
                  onClick={async () => {
                    await logout();
                    navigate("/");
                  }}
                >
                  Sign out
                </button>
              </>
            ) : (
              // Pre-launch: the only public action is joining the waitlist.
              <a href="/#waitlist" className="btn btn-primary btn-sm" data-testid="nav-waitlist">
                Join the waitlist
              </a>
            )}
          </div>
        </div>
      </nav>
      <main className="container">{children}</main>
      <footer className="footer">
        <div className="container">
          <div className="footer-contact">
            <div>
              <h5>Contact us</h5>
              <p className="muted" style={{ fontSize: 14, maxWidth: 320 }}>
                Questions, partnerships, or a game you want us to add? Send us a note and we'll
                reply to your email.
              </p>
            </div>
            <ContactForm />
          </div>
          <div className="footer-grid">
            <div>
              <Link to="/" className="brand"><span className="dot" aria-hidden />The Game <span className="b">Dude</span></Link>
              <p className="muted" style={{ marginTop: 12, maxWidth: 300, fontSize: 14 }}>
                On-demand game servers for friend groups. Any game, live in minutes — coming soon.
              </p>
            </div>
            <div>
              <h5>Learn more</h5>
              <a href="/#how">How it works</a>
              <a href="/#games">Games</a>
              <a href="/#faq">FAQ</a>
            </div>
            <div>
              <h5>Get early access</h5>
              <a href="/#waitlist">Join the waitlist</a>
            </div>
          </div>
          <div className="legal">
            © {new Date().getFullYear()} TheGameDude · Launching soon · Be first in — join the waitlist.
          </div>
        </div>
      </footer>
    </>
  );
}
